import loglevel from 'loglevel';

import isNil from 'lodash/isNil';

import {
  LINK_TYPE_NONE,
  LINK_TYPE_INTERNAL
} from 'zoomforth_codesbane_viewer/const/link_types.js';

import { DEFAULT_TILE_TAXONOMY } from 'grid_taxonomy.js';


export const toStructuredStandardPageContentItem = (item, sectionsById, menuItemsById)=> {

  // Copy Item and rename `assetType` and `contentType`
  // we dont do this on the backend because galleria/sections lenses depend on these property names
  const { assetType, contentType, ...newItem } = item;
  newItem.asset_type = assetType;
  newItem.content_type = contentType;

  // Handle page content links to menu items (referred to as anchor links)
  // We can't do this entirely on the backend because we need to reference the config item for this page
  if (item.tile_action_data && item.tile_action_data.type === 'legacy_anchor_link') {

    const anchorLinkMenuItem = menuItemsById[item.tile_action_data.anchorLinkMenuItemId];
    if (anchorLinkMenuItem) {
      newItem.tile_action_data = {
        type: LINK_TYPE_INTERNAL,
        subpageId: anchorLinkMenuItem.appAction.subpageId,
        sectionId: anchorLinkMenuItem.appAction.sectionId,
        contentUuid: anchorLinkMenuItem.appAction.contentUuid,
        shouldOpenOverlay:false // legacy page content item links to menu items (anchor links) were always "scroll to"s
      };
    } else {
      loglevel.warn(`Unable to find menuItem with id ${item.anchorLinkMenuItemId} in for "legacy_anchor_link"`);
      newItem.tile_action_data = {
        type: LINK_TYPE_NONE
      };
    }

  }

  if (isNil(newItem.tile_taxonomy)) {
    newItem.tile_taxonomy = DEFAULT_TILE_TAXONOMY;
  }
  
  return newItem;
};


export const toStructuredAsset = (assetData)=> {
  // we currently have no transformations that we need to apply to the asset,
  // but since we sometimes use asset data pulled from the server during user operation
  // we want to make sure we have the right structuring functions set up for that data
  return { ...assetData };
};


export const toStandardPageContentApiModel = (item)=> {

  // HACK: We intentionally do *not* convert our "underscore formatted" data
  // back into "camelcase" because, idiotically, our server expects underscore
  // inputs. This really needs to be fixed on backend, but there are legacyt dependencies
  // 
  // So, don't do this right now:
  //
  // const { asset_type, content_type, ...newItem } = item;
  // newItem.assetType = asset_type;
  // newItem.contentType = content_type;

  return { ...item };
};


